const FARMI_USER_AGENT_BASE = "Farmi-Mobile";
export function getOSVersion(userAgent) {
    const match = userAgent.match(/Farmi-Mobile-(Android|iOS)-(\d+\.\d+)/);
    if (!match) {
        return undefined;
    }
    return match[2];
}
export function isAndroid(userAgent) {
    return userAgent.startsWith(`${FARMI_USER_AGENT_BASE}-Android`);
}
export function isIOS(userAgent) {
    return userAgent.startsWith(`${FARMI_USER_AGENT_BASE}-iOS`);
}
export function isWebViewFarmi(userAgent = typeof window === "undefined"
    ? ""
    : window.navigator.userAgent) {
    return userAgent.startsWith(FARMI_USER_AGENT_BASE);
}
//# sourceMappingURL=user-agent.js.map